import React, { HTMLAttributes } from 'react';
import { useProviderConfig } from '../provider';
import { getPageIndicatorItemBaseStyle, getPageIndicatorItemSelectedStyle } from './styles';
import { PageIndicatorItemSize } from './types';

export interface PageIndicatorItemProps extends Omit<HTMLAttributes<HTMLButtonElement>, 'onClick'> {
  page: number;
  isSelected?: boolean;
  onClick?: (page: number) => void;
  disabled?: boolean;
  size?: PageIndicatorItemSize;
}

export const PageIndicatorItem = React.forwardRef<HTMLButtonElement, PageIndicatorItemProps>(
  ({ page, isSelected, onClick, disabled, size = 'medium', ...props }, ref) => {
    const { locale } = useProviderConfig();
    const ariaLabel =
      locale?.lang === 'en-US' ? `${locale?.accessibility.page} ${page}` : `${page} ${locale?.accessibility.page}`;
    return (
      <button
        role='tab'
        type='button'
        aria-label={ariaLabel}
        aria-selected={isSelected}
        css={[getPageIndicatorItemBaseStyle(size), isSelected && getPageIndicatorItemSelectedStyle(size)]}
        onClick={() => {
          onClick?.(page);
        }}
        ref={ref}
        disabled={disabled}
        {...props}
      >
        {page}
      </button>
    );
  },
);
